import { useCallback } from 'react';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { useMobileDetect } from '@/hooks/useMobileDetect';

/** iOS Safari only (not miniapp): avoid gray gap under fixed modals at scrollY ≈ 0 */
export function useIosNudgeScrollOffTop() {
  const { isIos } = useMobileDetect();
  const { isWebView } = useBridgeState();

  return useCallback(() => {
    if (!isIos || isWebView) return;

    if (window.scrollY < 1) {
      window.scrollTo(0, 1);
    }
  }, [isIos, isWebView]);
}
